module.exports = __webpack_public_path__ + "img/start-up.52b98f1d.png";